import OpenAPIClientAxios from 'openapi-client-axios';
import FullSchema from '@resident/openapi-specification/dist/full.json';
import constants from 'src/common/constants';

const isProd = process.env.RELEASE === 'production';
const server = isProd ? 'Production' : 'Staging';
const key = isProd ? constants.ACCESS_TOKEN_PRODUCTION : constants.ACCESS_TOKEN_STAGING;

const api = new OpenAPIClientAxios({
  definition: FullSchema,
  withServer: server,
  validate: false,
  axiosConfigDefaults: {
    headers: {
      Authorization: '',
      'X-Api-Key': key,
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
